import { render, staticRenderFns } from "./ItemTitleLeaf.vue?vue&type=template&id=085c4598&scoped=true&"
import script from "./ItemTitleLeaf.vue?vue&type=script&lang=js&"
export * from "./ItemTitleLeaf.vue?vue&type=script&lang=js&"
import style0 from "./ItemTitleLeaf.vue?vue&type=style&index=0&id=085c4598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c4598",
  null
  
)

export default component.exports